// extracted by mini-css-extract-plugin
export default {"heroContainer":"Menu_heroContainer__8M5O2","overlay":"Menu_overlay__WwCHh","title":"Menu_title__0Nmz0","typing":"Menu_typing__TXEIX","blink":"Menu_blink__XGzVd"};